<template>
  <div class="mail-list">
    <el-drawer
      :visible.sync="mailListShow"
      direction="rtl"
      :size="size"
      ref="drawer"
      :destroy-on-close="true"
      :show-close="false"
    >
        <el-input
        slot="title"
        clearable
        v-model="search"
        placeholder="请输入搜索内容"
        @change="onSearch"
      >
        <el-button slot="append" icon="el-icon-search"></el-button>
      </el-input>

      <div class="menus">
        <el-button type="primary" @click="closeDrawer">确定</el-button>
        <el-button type="danger" @click="onClear()">清除选择</el-button>
      </div>

      <!-- 多选 -->
      <template v-if="checkbox">
        <el-table
          ref="multipleTable"
          height="74vh"
          
          :data="tableData"
          tooltip-effect="dark"
          @selection-change="onSelection"
          @select="onSelections"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column
            :prop="prop1"
            :label="label1"
            min-width="120"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            v-if="prop2"
            :prop="prop2"
            :label="label2"
            min-width="120"
            header-align="center"
            align="center"
          ></el-table-column>
        </el-table>
      </template>

      <!-- 单选 -->
      <el-table
        v-else
        ref="singleTable"
        height="74vh"
        highlight-current-row
        :data="tableData"
        tooltip-effect="dark"
        
        @current-change="onRadioSelection"
      >
        <el-table-column
          :prop="prop1"
          :label="label1"
          min-width="120"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          v-if="prop2"
          :prop="prop2"
          :label="label2"
          min-width="120"
          header-align="center"
          align="center"
        ></el-table-column>
      </el-table>

      <pagination
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        :page-sizes="[10,20,50,100]"
        @pagination="getData"
      />
    </el-drawer>
  </div>
</template>
<script>
import axios from "axios";
import qs from "qs";
import Pagination from "@/components/Pagination";
export default {
  name: "mailList",
  components: {
    Pagination,
  },
  props: {
    module: {
      type: String,
      default: "getUserList",
    },
    checkbox: {
      type: Boolean,
      default: false,
    },
    // 是否为员工群发
    isGroup: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mailListShow: false,
      search: "",
      tableData: [],
      timer: null,
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
      },
      multipleSelection: [],
      tooken: null,
      size: "25%",
      prop1: "name",
      prop2: "",
      label1: "名称",
      label2: "",
    };
  },
  mounted() {
    let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
    this.tooken = userinfo;
  },
  methods: {
    async getData() {
      switch (this.module) {
        case "getCooperationUser":
          this.prop1 = "name";
          this.label1 = "名称";
          this.axios
            .post(
              "/crm/Assistant/getUserList",
              qs.stringify({
                phone: this.tooken.phone,
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                name: this.search,
                page: this.listQuery.page,
                number_page:this.listQuery.limit,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              const data = res.data;
              if (data.code == 1) {
                this.tableData = data.data;
                this.total = data.count;
              }
            })
            .catch(function (err) {});
          break;
        case "getAddressBook":
          this.prop1 = "name";
          this.label1 = "姓名";
          this.axios
            .post(
              "/crm/Assistant/getAddressBook",
              qs.stringify({
                phone: this.tooken.phone,
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                name: this.search,
                page: this.listQuery.page,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              const data = res.data;
              if (data.code == 1) {
                this.tableData = data.data.data;
                this.total = data.count;
              }
            })
            .catch(function (err) {});
          break;
        case "getUserList":
          this.prop1 = "name";
          this.prop2 = "";
          this.label1 = "名称";
          this.label2 = "";
          this.axios
            .post(
              "/crm/Assistant/getUserList",
              qs.stringify({
                phone: this.tooken.phone,
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                name: this.search,
                page: this.listQuery.page,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              const data = res.data;
              if (data.code == 1) {
                this.tableData = data.data;
                this.total = data.count;
              }
            })
            .catch(function (err) {});
          break;
        case "getUserLists":
          this.prop1 = "name";
          this.prop2 = "";
          this.label1 = "名称";
          this.label2 = "";
          this.axios
            .post(
              "/crm/Assistant/getUserLists",
              qs.stringify({
                phone: this.tooken.phone,
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                name: this.search,
                page: this.listQuery.page,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              const data = res.data;
              if (data.code == 1) {
                this.tableData = data.data;
                this.total = data.count;
                this.multipleSelection = [];
              }
            })
            .catch(function (err) {});
          break;
        case "ifRemoveUserTwo":
          this.prop1 = "name";
          this.prop2 = "";
          this.label1 = "名称";
          this.label2 = "";
          this.axios
            .post(
              "/home/sessionUser/ifRemoveUserTwo",
              qs.stringify({
                phone: this.tooken.phone,
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                name: this.search,
                page: this.listQuery.page,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              const data = res.data;
              if (data.code == 1) {
                this.tableData = data.data;
                this.total = data.count;
                this.multipleSelection = [];
              }
            })
            .catch(function (err) {});
          break;
        case "getGroupChat":
          this.size = "25%";
          this.label1 = "群名称";
          this.label2 = "群主";
          this.prop2 = "owner_name";
          this.axios
            .post(
              "/crm/Assistant/getGroupChat",
              qs.stringify({
                phone: this.tooken.phone,
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                name: this.search,
                page: this.listQuery.page,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              const data = res.data;
              if (data.code == 1) {
                this.tableData = data.data;
                this.total = data.count;
              }
            })
            .catch(function (err) {});
          break;
        case "getClientBaseList":
          this.size = "25%";
          this.label1 = "群名称";
          this.label2 = "群主";
          this.prop2 = "owner_name";
          this.axios
            .post(
              "/crm/Assistant/getClientBaseList",
              qs.stringify({
                phone: this.tooken.phone,
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                name: this.search,
                page: this.listQuery.page,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              const data = res.data;
              if (data.code == 1) {
                this.tableData = data.data.data;
                this.total = data.data.total;
              }
            })
            .catch(function (err) {});
          break;
        case "getClientBaseListOwner":
          this.size = "25%";
          this.label1 = "群主";
          this.prop1 = "owner_name";
          this.axios
            .post(
              "/crm/Assistant/getClientBaseListOwner",
              qs.stringify({
                phone: this.tooken.phone,
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                name: this.search,
                page: this.listQuery.page,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              const data = res.data;
              if (data.code == 1) {
                this.tableData = data.data.data;
                this.total = data.data.total;
              }
            })
            .catch(function (err) {});
          break;
        case "getKpiUserss":
          this.prop1 = "name";
          this.prop2 = "";
          this.label1 = "名称";
          this.label2 = "";
          this.axios
            .post(
              "/crm/KpiSet/getKpiUserss",
              qs.stringify({
                phone: this.tooken.phone,
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                name: this.search,
                page: this.listQuery.page,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              const data = res.data;
              if (data.code == 1) {
                this.tableData = data.data.data;
                this.total = data.data.total;
              }
            })
            .catch(function (err) {});
          break;
        default:
          break;
      }
    },
    onSearch() {
      this.getData();
    },
    onSelections(selection, row) {
      //群发的时候选择员工  只有有客户的员工才给出来 一个都没有就提示
      if (this.isGroup) {
        this.axios
          .post(
            "/crm/Assistant/ckeckUserContact",
            qs.stringify({
              usertoken: this.tooken.usertoken,
              account_id: this.tooken.account_id,
              userid: row.userid,
            }),
            {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
            }
          )

          .then((res) => {
            if (res.data.code == 1) {
              // this.multipleSelection.push(row);
            } else if (res.data.code == 0) {
              this.$message.error(res.data.msg);
              this.$refs.multipleTable.toggleRowSelection(row);
            }
          })
          .catch(function (err) {});
      }
    },
    onClear() {
      this.$emit("handleSelect", []);
      this.$refs.drawer.closeDrawer();
      this.multipleSelection = [];
    },
    onSelection(val) {
      // 选择联系人
      this.multipleSelection = val;
    },
    onRadioSelection(row) {
      //个人群发的时候选择员工  只有有客户的员工才给出来 一个都没有就提示
      if (this.isGroup) {
        this.axios
          .post(
            "/crm/Assistant/ckeckUserContact",
            qs.stringify({
              usertoken: this.tooken.usertoken,
              account_id: this.tooken.account_id,
              userid: row.userid,
            }),
            {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
            }
          )

          .then((res) => {
            if (res.data.code == 1) {
              // this.multipleSelection.push(row);
              this.multipleSelection = row;
              this.closeDrawer();
            } else if (res.data.code == 0) {
              this.multipleSelection = [];
              this.$message.error(res.data.msg);
            }
          })
          .catch(function (err) {});
      } else {
        this.multipleSelection = row;
        this.closeDrawer();
      }
    },
    // 打开抽屉
    open() {
      this.$nextTick(() => {
        this.tableData = [];
        this.getData();
        this.mailListShow = true;
      });
      console.log(this.options);
    },
    handleChange(){
      this.getData();
      // this.getIndex()
    },
    // 向父组件传递数据
    closeDrawer() {
      this.$emit("handleSelect", this.multipleSelection);
      this.$refs.drawer.closeDrawer();
      this.multipleSelection = [];
    },
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
  },
};
</script>
<style scoped>
.menus {
  margin-left: 2.0rem;
  margin-bottom: 2.0rem;
}
::v-deep .el-table th,
.el-table tr {
  background-color: #12baf3;
}
::v-deep .el-table th .cell,
.el-table tr .cell {
  color: #fff !important;
}
::v-deep .has-gutter > tr:nth-child(1) > th > .cell > label {
  display: none;
}
</style>